export default {
    templateEnvironment: process.env.NODE_ENV === 'production' ? 'PROD' : 'DEV',
    googleAnalytics: {
        smartnewsGA4Tracker: 'G-LXHB14Q404',
        tempestGA4Tracker: 'G-DQMZGMPHXN',
    },
    customDimensionMap: {
        pageType: 1,
        parentSectionName: 2,
        authorName: 3,
        publicationQuarter: 4,
        originalPublishDate: 7,
        premiumDetail: 9,
        channelName: 11,
        subscriptionStatus: 12,
        sectionPath: 13,
        eeaStatus: 14,
        trackedRichTermNames: 16,
        trackedExtendedAttributes: 17,
        primaryDomain: 21,
        mavenChannel: 22,
        coreVertical: 23,
        specialtyVerticals: 24,
        hasMavenUid: 29,
        author: 30,
        demonetizedReason: 32,
        sanitizedTitle: 33,
        videoTitle: 34,
        videoAuthorName: 35,
        monetization: 36,
        memberId: 37,
        contentItemId: 38,
        gaUserId: 39,
        contributorContent: 42,
        features: 43,
        mavenPageType: 44,
        suid: 46,
        membershipOfferSlug: 48,
        membershipProductName: 49,
        membershipProductCode: 50,
        membershipPlanCodes: 51,
        exclusiveContentType: 52,
        siteType: 53,
        recommendationAlgorithm: 54,
        trwDialogueLink: 55,
        experiments: 56,
        breakpoint: 57,
        characterCount: 58,
        isTrendingContent: 59,
        correlator: 60,
        directOnly: 61,
        inContentSlotCount: 62,
    },
    customEventDimensionMap: {
        videoTitle: 34,
        videoAuthorName: 35,
        videoMonetizationState: 47,
    },
};
//# sourceMappingURL=config.js.map